import { km } from '../../helpers/km';

type EventParams = {
  suggestionsCount: number;
  direction: 'departure' | 'destination';
  input: string;
  geoId: string;
};

export const aviaSuggestionSelect = (params: EventParams): void =>
  km({ name: 'avia_suggestion_select ', params });
